/** @hidden */
var WebGLHardwareTexture =
/** @class */
function () {
  function WebGLHardwareTexture(existingTexture, context) {
    if (existingTexture === void 0) {
      existingTexture = null;
    }

    this._context = context;

    if (!existingTexture) {
      existingTexture = context.createTexture();

      if (!existingTexture) {
        throw new Error("Unable to create webGL texture");
      }
    }

    this.set(existingTexture);
  }

  Object.defineProperty(WebGLHardwareTexture.prototype, "underlyingResource", {
    get: function get() {
      return this._webGLTexture;
    },
    enumerable: false,
    configurable: true
  });

  WebGLHardwareTexture.prototype.setUsage = function (textureSource, generateMipMaps, isCube, width, height) {};

  WebGLHardwareTexture.prototype.set = function (hardwareTexture) {
    this._webGLTexture = hardwareTexture;
  };

  WebGLHardwareTexture.prototype.reset = function () {
    this._webGLTexture = null;
  };

  WebGLHardwareTexture.prototype.release = function () {
    if (this._webGLTexture) {
      this._context.deleteTexture(this._webGLTexture);
    }

    this.reset();
  };

  return WebGLHardwareTexture;
}();

export { WebGLHardwareTexture };